import { useTranslation } from 'react-i18next';
import type { FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto } from '@/api/generated/models';
import { formatDuration, formatTimeSpan, parseTimeSpan } from '@/utils/timeclockTotals';

interface WorkTimeWithCreditProps {
  entry: FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto;
}

/**
 * The actual work time of a day and, below it, the credited time when the break rule of the
 * employee's schedule model changes it (paid break, or a mandatory break that would take the
 * day below the threshold — § 11 AZG).
 */
export function WorkTimeWithCredit({ entry }: WorkTimeWithCreditProps) {
  const { t } = useTranslation('timeclock');
  const work = parseTimeSpan(entry.totalWorkTime);
  const credited = parseTimeSpan(entry.creditedWorkTime);
  const showCredit = work !== null && credited !== null && credited !== work;

  return (
    <>
      {formatTimeSpan(entry.totalWorkTime)}
      {showCredit && (
        <div className="text-[11px] text-slate-500" title={t('stats.creditedHint')}>
          {t('stats.credited', { time: formatDuration(credited) })}
        </div>
      )}
    </>
  );
}
